import { defineComponent } from "vue";

export default defineComponent({
  methods: {
    viewDetailFile: function (type) {
      return;
    },
  },
});
